/**
 * @file The supported types for setting values
 * @author Tom Verschoore de la Houssaije
 */
/** The supported types for setting values */
export var SettingsValueTypes = {
    integer: 'INTEGER',
    date: 'DATE'
};
